import * as $ from 'jquery';
import jqueryValidation from 'jquery-validation'
import 'jquery-validation/dist/localization/messages_da'
import 'jquery-validation-unobtrusive'
import { Login } from './login';

/* Global inits */
$(function () {
    Login.init();
});